// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__fso+s"};